import React, { useState } from 'react';
import { api } from '../../api/api';
import Header from '../../components/header';
import Footer from '../../components/footer';

const AdminRegister = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!username || !password) {
      setError('Please enter both username and password.');
      return;
    }

    try {
      const response = await api.post('/api/all/admin_user', { username, password_hash: password });
      if (response.status === 201) {
        setSuccess('Admin user created successfully!');
        setUsername('');
        setPassword('');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'An error occurred during registration.');
    }
  };

  return (
    <div className={`w-full h-full flex flex-col bg-[#000000]`}>
      <Header />
      <div
        style={{
          backgroundImage: "url(assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex flex-col items-center justify-center w-full min-h-screen relative pt-6 px-4"
      >
        <div className="w-full max-w-md bg-black bg-opacity-60 p-8 rounded-lg border border-gray-800 shadow-lg">
          <h2 className="text-3xl font-bold mb-6 text-center text-white">Admin Registration</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="username">
                Username
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline"
                required
              />
            </div>
            {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
            {success && <p className="text-green-500 text-xs italic mb-4">{success}</p>}
            <div className="flex items-center justify-center">
              <button
                type="submit"
                className="bg-[#ED9B17] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminRegister;